<template>
  <div class="error-screen">
    <img v-bind="logo" >
    <forbidden v-show="error === 403"/>
    <not-found v-show="error === 404"/>
    <rate-limit-exceeded v-show="error === 429"/>
    <server-error v-show="error === 500"/>
    <service-unavailable v-show="error === 503"/>
    <p class="error-screen__backlink">
      <a href="javascript:window.history.back();">Take me back to the previous page</a>
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapState } from 'pinia'
import config from '@/config'
import { useAppStore } from '@/modules/app/app.store'
import Forbidden from './views/forbidden.vue'
import NotFound from './views/not-found.vue'
import RateLimitExceeded from './views/rate-limit-exceeded.vue'
import ServerError from './views/server-error.vue'
import ServiceUnavailable from './views/service-unavailable.vue'
import imageFile from '@/assets/img/logos/logo-donedone.svg'

export default defineComponent({
  name: 'ErrorPage',

  components: {
    Forbidden,
    NotFound,
    RateLimitExceeded,
    ServerError,
    ServiceUnavailable,
  },

  data() {
    return {
      logo: {
        src: imageFile,
        alt: 'Logo DoneDone',
      },
      marketingWebsiteUrl: 'https://www.donedone.com/',
    }
  },

  head(): any {
    return {
      title: this.error,
    }
  },

  computed: {
    ...mapState(useAppStore, ['error']),
  },

  created() {
    if (this.error === 401) {
      window.location.href = config.serverSideAppUrl
    }
  },
})
</script>

<style lang="scss">
.error-screen {
  padding: 50px 20px 0 20px;
  margin: 0 auto;
  max-width: 400px;

  img {
    display: block;
    margin: 0 auto;
  }

  h2 {
    margin-top: 10px;
    text-align: center;
  }

  p {
    margin-bottom: 20px;
  }

  &__backlink {
    text-align: center;
  }

  a {
    text-decoration: underline;
  }
}
</style>
